<template>
  <div class="editor-header-logo-container">
    <!-- <span v-if="!isEnableAddinPowerpoint">
      <span v-if="!isPresenterWhiteLabel">
        <aha-logo
          icon-only
          viewBox="0 0 1662 1602"
          width="27"
          height="26"
          class="hidden lg:block"
        />
        <aha-logo
          icon-only
          viewBox="0 0 1662 1602"
          width="22"
          height="21"
          class="lg:hidden"
        />
      </span>
      <aha-icon
        v-else
        name="presentation"
        class="text-secondary-50"
        viewBox="0 0 24 24"
        width="20"
        height="20"
      />
    </span> -->
    <span>
      <div class="back-presentation cursor-pointer" v-tooltip="'Back to My Presentations'" @click="handleClickOnLogo()">
        <aha-icon
          name="arrow-tail"
          viewBox="0 0 18 19"
          width="21"
          height="22"
        />
      </div>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config'

export default {
  computed: {
    ...mapState({
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      isGuestUser: (state) => state.currentUser.isGuest,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
  },
  methods: {
    handleClickOnLogo() {
      if (this.isEnableAddinPowerpoint) {
        window.location.href = `${config.presenterDomain}/apps/presentations`
        return
      }
      if (this.isGuestUser) {
        window.location.href = 'https://ahaslides.com/'
      } else if (this.$store.state.workingMode === 'team') {
        this.$router.push('/apps/team/workspace')
      } else {
        this.$router.push('/apps/presentations')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.editor-header-logo-container {
  @apply pl-3.5 pr-2 2xs:pr-5 flex items-center h-full;
  padding-right: 0.5rem;
}

.back-presentation {
  @apply rounded-full flex items-center justify-center w-10 h-10 hover:bg-base-40;
  backdrop-filter: blur(44px);
}
</style>
